<template>
  <div class="footer d-flex justify-content-center py-5 bg-main"> 
      <div class="d-flex flex-column align-items-end justify-content-center pr-5 border-right"> 
        <img src="/kisra.png" height="60" width="auto" alt="E-learning" />

      </div>
      <div class="d-flex align-items-center ms-5 text-white">
        <div>
          <img src="/logo-2.png" height="60" width="auto" alt="E-learning" />
        </div>
        <div class="text-start">
          <b>Saturday School Foundation</b><br>
          The Future of Our Education is in Your Hands
        </div> 
      </div> 
  </div>
</template>

<script>
export default {
  name: "mainFooter",
  data() {
    return {};
  },
};
</script>
<style lang="scss">
@import "/src/assets/scss/style.scss";

// .foot_left,.foot_right{
//   display: flex;
//   flex-wrap: nowrap;
//   flex-direction: column;
//   justify-content: space-around;
// }
.mainFooter>.row {
  height: 80px;
  padding-top: 20px;
}

.foot_left {
  color: white;
  border-right: 2px solid white;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.foot_right {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
